import { Product } from '../../../../clients/quipli-service/product/product';
import { ProductImageV2 } from '../../../../components/image/product/product-image-v2';
import { Typography } from '../../../../components/typography/typography';

export const InspectionUnitHeader = ({
  product,
  unitNumber,
}: {
  product: Product;
  unitNumber: string; // either unitNumber or serialNumber;
}) => {
  return (
    <div className="flex items-center justify-between bg-grey-50 rounded-md p-2 my-3">
      <div className="flex items-center">
        <ProductImageV2 productId={product.id} profile="MINI" />
        <div className="flex flex-col ml-2">
          <Typography type="text-sm" weight="medium">
            {product.name}
          </Typography>
          <Typography type="text-xs" className="text-grey-500">
            Unit {unitNumber}
          </Typography>
        </div>
      </div>
    </div>
  );
};
